import { makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { store } from "../../store";
import type { RepositoryPedestrianDevices } from "src/domain/repositories/repository-pedestrian-devices";
import { FormCreatePedestrianDevice } from "../molecules/form-create-pedestrian-device";
import { FormUpdatePedestrianDevice } from "../molecules/form-update-pedestrian-device";

export type ListCommandButtonsPedestrianDevicesProps = Omit<
    ListCommandButtonsProps<RepositoryPedestrianDevices>,
    "list" | "createForm" | "listState"
>;

@observer
export class ListCommandButtonsPedestrianDevices extends React.Component<ListCommandButtonsPedestrianDevicesProps> {
    constructor(props: ListCommandButtonsPedestrianDevicesProps) {
        super(props);
        makeObservable(this);
    }

    public render(): JSX.Element {
        return (
            <ListCommandButtons<RepositoryPedestrianDevices>
                createForm={FormCreatePedestrianDevice}
                updateForm={FormUpdatePedestrianDevice}
                createButtonText={store.i18n.t("listPedestrianDevices.createButton.name")}
                createDialogTitle={store.i18n.t("listPedestrianDevices.createDialog.title")}
                updateDialogTitle={store.i18n.t("listPedestrianDevices.updateDialog.title")}
                listState={store.serviceListStates.pedestrianDevices}
                {...this.props}
            />
        );
    }
}
